<template>
  <v-dialog
    v-model="show"
    max-width="800"
    transition="spin-in-out-transition"
    content-class="company"
  >
    <v-card class="main-card position-relative" style="z-index: 2" height="500">
      <img
        class="position-absolute right-8 top-8 cursor-pointer"
        :src="iconClose"
        width="50"
        height="50"
        alt="close"
        @click="close"
      />
      <v-container class="h-100">
        <v-row class="h-100">
          <v-col class="d-flex justify-center align-center flex-column h-100">
            <h2
              class="text-center notify--title amber--text text-h4 font-weight-bold"
            >
              {{ $t('common.congratulation') }}
            </h2>
            <div
              class="text-h5 text-center font-weight-regular black--text mt-3 mb-2"
            >
              <span v-if="$attrs.gift">
                {{ $t('common.receivedPointFromCompany', { n: $attrs.gift }) }}
              </span>
              <span v-else>
                {{
                  $t('common.receivedCreditFromCompany', { n: $attrs.point })
                }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <confetti-background />
    <!--    <div class="decorator-wrap">-->
    <!--      <div class="decorator decorator&#45;&#45;coin">-->
    <!--        <v-img src="@/assets/image/notification/template/popup_top_gift.png"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="decorator decorator&#45;&#45;balloon">-->
    <!--        <v-img src="@/assets/image/notification/template/popup_popup_balloons.png"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="decorator decorator&#45;&#45;tinsel">-->
    <!--        <v-img src="@/assets/image/notification/template/popup_tassels.png"-->
    <!--               width="900"-->
    <!--               :aspect-ratio="900/485"-->
    <!--               cover-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="decorator decorator&#45;&#45;right">-->
    <!--        <v-img src="@/assets/image/notification/template/popup_right_credit.png"-->
    <!--               width="350px"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <v-container class="decorator decorator&#45;&#45;left" style="height: 485px">-->
    <!--        <div class="container-overlay"/>-->
    <!--        <v-row align="center" style="height: 100%">-->
    <!--          <v-col cols="7">-->
    <!--            <h2 class="text-center notify&#45;&#45;title amber&#45;&#45;text">-->
    <!--              {{ $t('common.congratulation') }}-->
    <!--            </h2>-->
    <!--            <div class="text-h5 text-center font-weight-regular white&#45;&#45;text mb-2">-->
    <!--              <span v-if="$attrs.gift">-->
    <!--                {{ $t('common.receivedPointFromCompany', { n: $attrs.gift }) }}-->
    <!--              </span>-->
    <!--              <span v-else>-->
    <!--                {{ $t('common.receivedCreditFromCompany', { n: $attrs.point }) }}-->
    <!--              </span>-->
    <!--            </div>-->
    <!--            <div class="d-flex justify-center" v-if="$attrs.comment !== 'automation'">-->
    <!--              <v-col cols="6" class="py-0">-->
    <!--                <v-img src="@/assets/image/notification/template/popup_comment.png">-->
    <!--                  <div class="notify&#45;&#45;message-content">-->
    <!--                    {{ $attrs.comment }}-->
    <!--                  </div>-->
    <!--                </v-img>-->
    <!--              </v-col>-->
    <!--            </div>-->
    <!--            <div class="d-flex">-->
    <!--              <v-col class="text-center">-->
    <!--                <v-btn rounded-->
    <!--                       color="white"-->
    <!--                       light-->
    <!--                       class="indigo&#45;&#45;text darken-4 c-btn&#45;&#45;birthday"-->
    <!--                       @click="close"-->
    <!--                >-->
    <!--                  OK-->
    <!--                  <div class="c-btn&#45;&#45;birthday&#45;&#45;content"/>-->
    <!--                </v-btn>-->
    <!--              </v-col>-->
    <!--            </div>-->
    <!--          </v-col>-->
    <!--        </v-row>-->
    <!--      </v-container>-->
    <!--    </div>-->
  </v-dialog>
</template>

<script>
import ConfettiBackground from '@/components/Layout/SystemNotification/Template/components/ConfettiBackground.vue';
import iconClose from '@/assets/icons/close.png';
import templateMixin from './templateMixin';

export default {
  name: 'NewMessage',
  components: { ConfettiBackground },
  mixins: [templateMixin],
  data: () => ({
    sentGift: false,
    messageData: {
      point: undefined,
      message: undefined,
      categoryId: undefined,
    },
    iconClose,
  }),
};
</script>

<style lang="sass">
.company
  box-shadow: none !important
  .main-card
    background-image: url("../../../../assets/image/notification/template/company-send-point.png")
    position: relative
    background-color: transparent !important
    box-shadow: none !important
    border-color: unset !important
    background-size: contain !important
</style>
